import { generateUUID } from '@wix/form-schema';
import { useMemo } from 'react';
export const dummyBi = {
  log: () => Promise.resolve(),
  report: () => Promise.resolve(),
  flush: () => Promise.resolve(),
  updateDefaults: () => dummyBi
};
export const useFormBi = (form, bi, biFormFillSessionId) => {
  var _form$properties2;
  const formEditSessionId = useMemo(generateUUID, []);
  return useMemo(() => {
    if (!bi) {
      return dummyBi;
    }
    return {
      ...bi,
      report: payload => {
        var _form$properties;
        return bi.report({
          ...payload,
          params: {
            form_fill_session_id: biFormFillSessionId || formEditSessionId,
            form_guid: form == null ? void 0 : form.id,
            form_schema_name: (_form$properties = form.properties) == null ? void 0 : _form$properties.name,
            form_url: location.href,
            namespace: form.namespace,
            ...(payload == null ? void 0 : payload.params)
          }
        });
      }
    };
  }, [bi, biFormFillSessionId, form == null ? void 0 : form.id, form.namespace, (_form$properties2 = form.properties) == null ? void 0 : _form$properties2.name, formEditSessionId]);
};
//# sourceMappingURL=use-form-bi.js.map